import React from 'react';
import { checkPasswordStrength } from '../../../lib/utils';

interface PasswordStrengthBarProps {
  password: string;
}

const getStrengthConfig = (score: number): { label: string; color: string } => {
  if (score <= 2) return { label: '弱い', color: '#EF4444' };
  if (score === 3) return { label: '普通', color: '#F59E0B' };
  return { label: '強い', color: '#22C55E' };
};

export const PasswordStrengthBar: React.FC<PasswordStrengthBarProps> = ({ password }) => {
  if (!password) return null;

  const { score } = checkPasswordStrength(password);
  const widthPercent = (score / 5) * 100;
  const { label, color } = getStrengthConfig(score);

  return (
    <div className="mt-2 mb-1">
      <div
        className="w-full h-[4px] bg-[#E2E8F0] rounded-[2px] overflow-hidden"
        data-testid="password-strength-bar"
        role="progressbar"
        aria-label="パスワード強度"
        aria-valuemin={0}
        aria-valuemax={5}
        aria-valuenow={score}
      >
        <div
          className="h-full rounded-[2px] transition-all"
          style={{ width: `${widthPercent}%`, backgroundColor: color }}
        />
      </div>
      <p
        className="text-[11px] mt-0.5"
        style={{ color }}
        data-testid="password-strength-feedback"
      >
        パスワード強度: {label}
      </p>
    </div>
  );
};
